import React, { useState, useEffect } from "react";
import {injectIntl} from "react-intl";
import {Card, CardBody, CardHeader, CardHeaderToolbar} from "../../../../_metronic/_partials/controls";
import {
    Button,
    Dialog, DialogActions, DialogContent, DialogContentText,
    DialogTitle, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import { getRouteRecordDetails, getRoutinSupplierInfo, patchRouteRecordDriverTruck } from "./routesCrud";
import { fetchUserPermissions } from "../../Buyer/UsersCrud";

const useStyles = makeStyles(theme => ({
    root: {
        width: "100%"
    },
    heading: {
        fontSize: theme.typography.pxToRem(20),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    }
}));

function RouteRecordDetail({ accessToken, routeRecordId, setIsRouteRecordDetailsClicked }){

    const classes = useStyles();

    const [routeRecordDetails, setRouteRecordDetails] = useState(null);
    const [expanded, setExpanded] = useState("");
    const [isDataFetched, setIsDataFetched] = useState(false);
    const [permissions, setPermissions] = useState([]);
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [supplierInfo, setSupplierInfo] = useState(null);
    const [editSelectedDriver, setEditSelectedDriver] = useState("");
    const [editSelectedTruck, setEditSelectedTruck] = useState("");
    const [isSaving, setIsSaving] = useState(false);
    const [editError, setEditError] = useState("");

    const EDITABLE_STATUSES = ["Completed", "Sent to WMS"];
    const canEdit = permissions.includes("route_management") &&
        routeRecordDetails &&
        EDITABLE_STATUSES.includes(routeRecordDetails.status);

    const fetchRouteRecordDetails = async () => {
        // dispatch(getOrdersByUser(user.id, queryParams))
        getRouteRecordDetails(accessToken, routeRecordId).then(response => {
            console.log("~~~~~~", response.data)
            setRouteRecordDetails(response.data)
            setIsDataFetched(true)
        }).catch(error => console.log(error))
    }

    // Helper function to check if a product has multiple units of measurement
    const hasMultipleUnits = (product) => {
        return product.unitsOfMeasurement && product.unitsOfMeasurement.length > 1;
    }
    
    useEffect(() => {
        fetchRouteRecordDetails()
    }, []);

    useEffect(() => {
        if (accessToken) {
            fetchUserPermissions(accessToken)
                .then(res => setPermissions(res.data || []))
                .catch(() => setPermissions([]));
        }
    }, [accessToken]);

    const handleAccordionChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : "")
    };

    const handleBack = () => {
        setExpanded("")
        setIsRouteRecordDetailsClicked(false)
    };

    function toFixedCustom(num, fixed) {
        var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
        return num.toString().match(re)[0];
    }

    const handleOpenEditDialog = async () => {
        setEditError("");
        try {
            const res = await getRoutinSupplierInfo(accessToken);
            setSupplierInfo(res.data);
            const driverId = routeRecordDetails?.selectedDriver || routeRecordDetails?.driver?.[0]?._id?.toString() || "";
            const truckId = routeRecordDetails?.selectedTruck || routeRecordDetails?.truck?.[0]?._id?.toString() || "";
            setEditSelectedDriver(driverId);
            setEditSelectedTruck(truckId);
            setEditDialogOpen(true);
        } catch (err) {
            setEditError("Failed to load driver and truck options");
        }
    };

    const handleCloseEditDialog = () => {
        setEditDialogOpen(false);
        setEditError("");
        setSupplierInfo(null);
    };

    const handleSaveDriverTruck = async () => {
        setEditError("");
        setIsSaving(true);
        try {
            await patchRouteRecordDriverTruck(
                routeRecordId,
                { selectedDriver: editSelectedDriver, selectedTruck: editSelectedTruck },
                accessToken
            );
            handleCloseEditDialog();
            fetchRouteRecordDetails();
        } catch (err) {
            setEditError(err.response?.data?.error || err.message || "Failed to update");
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <>
            <button type="button" className="btn btn-primary mb-6" onClick={() => handleBack()} >Back</button>
            {
                isDataFetched ?
                    <>
                        <Card>
                            <CardHeader title={`Route Record Detail`}>
                                {canEdit && (
                                    <CardHeaderToolbar>
                                        <button type="button" className="btn btn-success cursor-pointer" onClick={handleOpenEditDialog}>
                                            Edit Driver/Truck
                                        </button>
                                    </CardHeaderToolbar>
                                )}
                            </CardHeader>
                            <CardBody>
                                <div className="row">
                                    <div className="col-2">
                                        <span className={'text-dark-75 font-weight-bolder d-block font-size-lg'}>
                                            Date: 
                                        </span>
                                    </div>
                                    <div className="col-2">
                                        <span className={'text-dark-75 d-block font-size-lg'}>
                                            {routeRecordDetails.routeDate}
                                        </span>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-2">
                                        <span className={'text-dark-75 font-weight-bolder d-block font-size-lg'}>
                                            Status: 
                                        </span>
                                    </div>
                                    <div className="col-2">
                                        <span className={'text-dark-75 d-block font-size-lg'}>
                                            {routeRecordDetails.status}
                                        </span>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-2">
                                        <span className={'text-dark-75 font-weight-bolder d-block font-size-lg'}>
                                            Driver: 
                                        </span>
                                    </div>
                                    <div className="col-2">
                                        <span className={'text-dark-75 d-block font-size-lg'}>
                                            {routeRecordDetails.driver?.[0]?.name || 'N/A'}
                                        </span>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-2">
                                        <span className={'text-dark-75 font-weight-bolder d-block font-size-lg'}>
                                            Truck: 
                                        </span>
                                    </div>
                                    <div className="col-2">
                                        <span className={'text-dark-75 d-block font-size-lg'}>
                                            {routeRecordDetails.truck?.[0]?.name || 'N/A'}
                                        </span>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <div>
                            {
                                <div className="col-12 my-5">
                                    {routeRecordDetails.orders.map((order, orderIndex) => (
                                        <>
                                            <ExpansionPanel square expanded={expanded === 'panel' + orderIndex} onChange={handleAccordionChange('panel' + orderIndex)}>
                                                <ExpansionPanelSummary
                                                    expandIcon={<ExpandMoreIcon/>}
                                                    aria-controls={'panel-content-' + orderIndex}
                                                    id={'panel-header-' + orderIndex}
                                                    >
                                                    <Typography className={classes.heading}>
                                                        #{order.orderNumber}
                                                    </Typography>
                                                    <Typography className={classes.secondaryHeading}>{order.companyName}</Typography>
                                                </ExpansionPanelSummary>
                                                <ExpansionPanelDetails>
                                                    <div className="col-12 my-5">
                                                        <Card>
                                                            <div className="row mt-5 ml-5">
                                                                <div className="col-2">
                                                                    <span className={'text-dark-75 font-weight-bolder d-block font-size-lg'}>
                                                                        Comment
                                                                    </span>
                                                                </div>
                                                                <div className="col-2">
                                                                    <span className={'text-dark-75 d-block font-size-lg'}>
                                                                        {order.comment}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            { order.customerPo && order.customerPo != '' ?
                                                                <div className="row mt-2 ml-5">
                                                                    <div className="col-2">
                                                                        <span className={'text-dark-75 font-weight-bolder d-block font-size-lg'}>
                                                                            Customer PO
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-2">
                                                                        <span className={'text-dark-75 d-block font-size-lg'}>
                                                                            {order.customerPo}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            :
                                                                null
                                                            }
                                                            
                                                            <div className="row mt-2 ml-5">
                                                                <div className="col-2">
                                                                    <span className={'text-dark-75 font-weight-bolder d-block font-size-lg'}>
                                                                        Total Items: 
                                                                    </span>
                                                                </div>
                                                                <div className="col-2">
                                                                    <span className={'text-dark-75 d-block font-size-lg'}>
                                                                        {order.totalProductQty}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2 ml-5">
                                                                <div className="col-2">
                                                                    <span className={'text-dark-75 font-weight-bolder d-block font-size-lg'}>
                                                                        Total Price: 
                                                                    </span>
                                                                </div>
                                                                <div className="col-2">
                                                                    <span className={'text-dark-75 d-block font-size-lg'}>
                                                                        ${order.totalCost}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            <CardBody>
                                                                <table className="table table-head-custom table-head-bg table-borderless table-vertical-center table-padding">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Product</th>
                                                                            <th className="text-center" >SKU</th>
                                                                            <th className="text-center" >Price</th>
                                                                            <th className="text-center" >Product Qty.</th>
                                                                            <th className="text-center" >UoM</th>
                                                                            <th className="text-center" >Total Amount</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {order?.products?.map((product,index) =>  (
                                                                            <tr key={product._id}>
                                                                                <td className="border-top-0 pl-0">
                                                                                    { product.imagePath ? 
                                                                                        <div className="symbol symbol-40 flex-shrink-0 mr-4 bg-light">
                                                                                            <div className="symbol-label"
                                                                                                style={{backgroundImage: "url(" + product.imagePath + ")"}}></div>
                                                                                        </div>
                                                                                        :
                                                                                        null
                                                                                    }
                                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                                                                        {product.description ? product.description : product.name}
                                                                                    </span>
                                                                                </td>
                                                                                <td>
                                                                                    {product.itemNumber && (
                                                                                        <span className="text-dark-75 font-weight-bolder d-block text-center font-size-lg">
                                                                                            {product.itemNumber}
                                                                                        </span>
                                                                                    )}
                                                                                    <span className="text-dark-75 font-weight-bolder d-block text-center font-size-lg">
                                                                                        {product.sku}
                                                                                    </span>
                                                                                </td>
                                                                                <td className="border-top-0 text-right py-2 align-middle">
                                                                                    <span className="text-dark-75 font-weight-bolder d-block text-center font-size-lg">
                                                                                        {product.listPrice || product.listPrice == '' ?                  
                                                                                            product.listPrice
                                                                                            :
                                                                                            product.price
                                                                                        }
                                                                                    </span>
                                                                                </td>
                                                                                <td className="border-top-0 text-center py-2 align-items-center" style={{minWidth:"125px"}}>
                                                                                    <span className="text-dark-75 font-weight-bolder d-block text-center font-size-lg">{product.amount}</span>
                                                                                </td>
                                                                                <td className="border-top-0 text-center py-2 align-middle">
                                                                                    <span className="text-dark-75 font-weight-bolder d-block text-center font-size-lg">
                                                                                        {(() => {
                                                                                            const uom = product.selectedUnit || product.defaultUnitOfMeasurement;
                                                                                            const name = uom?.name ?? 'ea';
                                                                                            const conversionFactor = uom?.conversionFactor ?? 1;
                                                                                            return `${name} (${conversionFactor})`;
                                                                                        })()}
                                                                                    </span>
                                                                                </td>
                                                                                <td>
                                                                                    <span className="text-dark-75 font-weight-bolder d-block text-center font-size-lg">
                                                                                        {(() => {
                                                                                            const conversionFactor = (product.selectedUnit || product.defaultUnitOfMeasurement)?.conversionFactor ?? 1;
                                                                                            return product.listPrice ?
                                                                                                <span className="label label-lg label-light-primary label-inline">${toFixedCustom((product.listPrice * product.amount * conversionFactor), 2)}</span>
                                                                                                :
                                                                                                <span>${toFixedCustom((product.price * product.amount * conversionFactor), 2)}</span>;
                                                                                        })()}
                                                                                    </span>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>

                                                            </CardBody>
                                                        </Card>
                                                    </div>
                                                </ExpansionPanelDetails>
                                            </ExpansionPanel>
                                        </>
                                    ))}
                                </div>

                            }
                            
                        </div>
                    </>
                :
                    <div className="row justify-content-center mt-20">
                        <span className="ml-3 spinner spinner-lg spinner-primary"></span>
                    </div>

            }
            <Dialog open={editDialogOpen} onClose={handleCloseEditDialog} maxWidth="sm" fullWidth>
                <DialogTitle>Edit Driver and Truck</DialogTitle>
                <DialogContent>
                    {editError && (
                        <DialogContentText color="error" style={{ marginBottom: 16 }}>
                            {editError}
                        </DialogContentText>
                    )}
                    <FormControl fullWidth style={{ marginTop: 16, marginBottom: 16 }}>
                        <InputLabel>Driver</InputLabel>
                        <Select
                            value={editSelectedDriver}
                            onChange={(e) => setEditSelectedDriver(e.target.value)}
                            label="Driver"
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {(supplierInfo?.supplierDrivers || []).map((d) => (
                                <MenuItem key={d._id} value={d._id?.toString?.() || d._id}>
                                    {d.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth style={{ marginBottom: 16 }}>
                        <InputLabel>Truck</InputLabel>
                        <Select
                            value={editSelectedTruck}
                            onChange={(e) => setEditSelectedTruck(e.target.value)}
                            label="Truck"
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {(supplierInfo?.supplierTrucks || []).map((t) => (
                                <MenuItem key={t._id} value={t._id?.toString?.() || t._id}>
                                    {t.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <button type="button" className="btn btn-light" onClick={handleCloseEditDialog} disabled={isSaving}>
                        Cancel
                    </button>
                    <button type="button" className="btn btn-success" onClick={handleSaveDriverTruck} disabled={isSaving}>
                        {isSaving ? "Saving..." : "Save"}
                    </button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default injectIntl(RouteRecordDetail);